(() => {
  'use strict';

  if (window.__izzatCartVariantSelectorReady) return;
  window.__izzatCartVariantSelectorReady = true;

  const selector = '[data-cart-variant-select]';

  const cartSections = () => {
    const ids = Array.from(document.querySelectorAll('cart-items-component'))
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);
    return [...new Set([...ids, 'cart-icon-bubble', 'cart-drawer'])];
  };

  const announce = (select, message) => {
    const status = select.closest('.cart-item__variant-picker')?.querySelector('[data-cart-variant-status]');
    if (status) status.textContent = String(message || '');
  };

  const changeVariant = async (select) => {
    const oldLineKey = String(select.dataset.lineKey || '');
    const currentVariantId = String(select.dataset.currentVariantId || '');
    const nextVariantId = String(select.value || '');
    if (!oldLineKey || !/^\d+$/.test(nextVariantId) || nextVariantId === currentVariantId) return;

    select.disabled = true;
    select.setAttribute('aria-busy', 'true');
    announce(select, '');

    try {
      const cartResponse = await fetch((window.routes?.cart_url || '/cart') + '.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      const cart = await cartResponse.json();
      if (!cartResponse.ok || !Array.isArray(cart.items)) throw new Error(window.cartStrings?.error || 'Unable to update cart.');

      const sourceLine = cart.items.find((item) => String(item.key) === oldLineKey);
      if (!sourceLine) throw new Error(window.cartStrings?.error || 'Unable to update cart.');

      const targetLine = cart.items.find((item) => (
        String(item.key) !== oldLineKey && String(item.variant_id || item.id) === nextVariantId
      ));
      const targetQuantity = Number(targetLine?.quantity || 0) + Number(sourceLine.quantity || 0);
      const updates = { [oldLineKey]: 0, [targetLine?.key || nextVariantId]: targetQuantity };

      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          updates,
          sections: cartSections(),
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok || result?.status) {
        throw new Error(result?.description || result?.message || window.cartStrings?.error || 'Unable to update cart.');
      }

      select.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: result,
          sourceId: oldLineKey,
          data: {
            source: 'cart-variant-selector',
            itemCount: result.item_count,
            sections: result.sections,
          },
        },
      }));
    } catch (error) {
      select.value = currentVariantId;
      announce(select, error instanceof Error ? error.message : String(error));
      select.disabled = false;
      select.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('change', (event) => {
    const select = event.target instanceof Element ? event.target.closest(selector) : null;
    if (select) void changeVariant(select);
  });
})();
